<template>
  <v-card style="border-radius: 30px;">
      <v-card-title>
        <v-row align="center" justify="center">
            <h3 class="primary--text font-weight-black text-uppercase">
              Dejar de sincronizar con el SAT
            </h3>
        </v-row>
      </v-card-title>
      <v-card-text class="mt-3" v-if="$store.getters.user.SATdownloading === false">
        <v-img src="@/assets/images/question.gif" max-width="20%" class="mx-auto"/>
        <v-row class="text-center primary--text mt-3" align="center" justify="center">
          <h4>Al desconectar tu cuenta del SAT no podremos descargar tus facturas diariamente y tendrás que cargar los archivos XML de manera manual</h4>
          <h4 class="mt-3">¿Estás seguro de querer hacer esto?</h4>
        </v-row>
      </v-card-text>
      <v-card-text class="mt-3" v-if="$store.getters.user.SATdownloading === true">
        <v-row class="text-center primary--text mt-3" align="center" justify="center">
          <h4>Tus facturas están siendo descargadas en este momento, por lo que no es posible desconectar del SAT.</h4>
          <h4 class="mt-3">Intenta más tarde</h4>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-row align="center" justify="center">
          <v-btn
            rounded
            @click="$emit('onClose')"
            class="font-weight-bold mr-4">
            <span v-if="$store.getters.user.SATdownloading === true">Ok</span>
            <span v-else>No</span>
          </v-btn>
          <v-btn
            v-if="$store.getters.user.SATdownloading === false"
            dark
            rounded
            color="primary"
            @click="deactivateCredentials()"
            class="font-weight-bold">Sí, desconectar</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
</template>

<script>
import SATService from '@/services/SATService'

export default {
  name: 'DisconectSat',
  data () {
    return {
      user: this.$store.getters.user
    }
  },
  methods: {
    async deactivateCredentials () {
      if (this.$store.getters.user.SATdownloading) {
        this.$swal({
          title: '¡Error!',
          html: 'Tus facturas se están descargando, no es posible desincronizar en este momento',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          confirmButtonColor: '#1374F2',
          showCloseButton: true
        })
        return
      }
      const loader = this.$loading.show()
      try {
        await SATService.updateCredentials({ clientId: this.$store.getters.user.clientId, syncActive: false })
        this.user.SATsyncActive = false
        this.user.SATlastSync = null
        await this.$store.dispatch('setUser', { user: this.user, isLoggedIn: true })
        loader.hide()
        this.$emit('onClose')
        this.$swal('Éxito', 'La sincronización con el SAT ha sido desactivada', 'success')
      } catch (error) {
        console.error(error)
        loader.hide()
        this.$swal({
          title: '¡Error!',
          html: 'Tenemos problemas internos, por favor intenta más tarde',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          confirmButtonColor: '#1374F2',
          showCloseButton: true
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
